import React from 'react';
class ImageSelect extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const singleImage = (item) => {
      if (item.image_url) {
        return (
          <span className="single-input image-select" key= {item.key}>
            <input type = "checkbox" checked={item.isActive} id= { item.key } value= {item.key} onChange = {(e) => this.props.onSelectImage(e, item)} />
            <label htmlFor= { item.key }>
              <img src={item.image_url} alt={item.key}/>
            </label>
          </span>
          );
      }
    };
    return (
      <span className="checkbox-input-content">
        { this.props.options.length ? this.props.options.map(singleImage) : null }
      </span>
    );
  }
}

ImageSelect.propTypes = {
  'multiselect': React.PropTypes.string,
  'options': React.PropTypes.array,
  'defaultvalue': React.PropTypes.array,
  'onSelectImage': React.PropTypes.func,
};

export default ImageSelect;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/imageselect.js
 **/